import { render, staticRenderFns } from "./AccessControlCustomer.vue?vue&type=template&id=34beeaa1&"
import script from "./AccessControlCustomer.vue?vue&type=script&lang=js&"
export * from "./AccessControlCustomer.vue?vue&type=script&lang=js&"
import style0 from "./AccessControlCustomer.vue?vue&type=style&index=0&id=34beeaa1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports